// i18n area 'system' — locale pt-PT (pt-PT, task #171, onda 1): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/system.pt-PT.meta.json.
// DA RIVEDERE DA MADRELINGUA (F7 rinviata): rinomina F1 arquivo→«cópia de configuração» (#247).
import type { enUS } from './system'

export const ptPT: typeof enUS = {
  diagnostics: {
    title: 'Diagnóstico',
    subtitle: 'O que está mal, o pior primeiro — a mesma lente de tvirt diagnose',
    reload: 'Recarregar',
    loadError: 'Não foi possível ler o diagnóstico',
    exportBundle: 'Exportar pacote',
    exportError: 'Não foi possível gerar o pacote',
    noProblem: 'Nenhum problema nas áreas inspecionadas',
    nothingInspected: 'NADA foi inspecionado — isto não é um atestado de boa saúde',
    inspected: 'Inspecionadas',
    notInspected: 'NÃO inspecionadas',
    localHint: 'As áreas locais do nó (unidades systemd, journal) só se leem na CLI: tvirt diagnose --area local — o caminho quando a API não responde.',
    thresholds: 'tarefas falhadas em {hours} h, heartbeat atrasado além de {seconds} s',
    severity: {
      critical: 'Crítico',
      warning: 'Aviso',
      unknown: 'Desconhecido'
    }
  },
  explorer: {
    title: 'Explorador de recursos',
    root: 'Raiz',
    empty: 'Nenhum recurso neste scope',
    previewHint: 'Selecione um objeto para ver a pré-visualização',
    open: 'Abrir',
    openScoped: 'Abrir a lista neste scope',
    kinds: {
      vm: 'VM',
      vmTemplate: 'Template VM',
      ct: 'CT',
      ctTemplate: 'Template CT',
      app: 'App',
      overlayNetwork: 'Rede overlay',
      networkService: 'Serviço de rede',
      fabric: 'Fabric',
      subnet: 'Subnet',
      storage: 'Pool de storage',
      disk: 'Disco',
      catalogFile: 'Ficheiro de catálogo',
      ociRegistry: 'Registo OCI',
      ociImage: 'Imagem OCI',
      cephCluster: 'Cluster Ceph',
      backupDestination: 'Destino de backup',
      user: 'Utilizador',
      group: 'Grupo',
      role: 'Função',
      credential: 'Credencial',
      tag: 'Tag',
      proximityRule: 'Regra de proximidade'
    }
  },
  tags: {
    title: 'Tags',
    empty: 'Nenhuma tag',
    add: 'Adicionar tag',
    remove: 'Remover',
    name: 'Tag',
    value: 'Valor',
    save: 'Guardar',
    saveError: 'Impossível guardar as tags',
    loadError: 'Impossível carregar o vocabulário das tags',
    noVocabulary: 'Nenhuma tag disponível para este tipo de recurso',
    overwrite: 'Substituir o valor atual',
    createTitle: 'Criar tag',
    editTitle: 'Editar tag',
    nameHint: 'Letras, dígitos, pontos, hífenes e underscores — sem ":" nem "/"; o prefixo tvirt- está reservado à plataforma',
    cardinality: 'Cardinalidade',
    cardinalitySingle: 'Um único valor',
    cardinalityMultiple: 'Vários valores',
    cardinalityHint: 'Com um único valor, voltar a atribuir a tag pede para o substituir',
    autoCreate: 'Autocriação de valores',
    autoCreateOn: 'Na atribuição',
    autoCreateOff: 'Só declarados',
    autoCreateHint: 'Ativada: atribuir um valor novo cria-o. Desativada: só se atribuem os valores declarados',
    values: 'Valores',
    noValues: 'Nenhum valor declarado',
    addValue: 'Adicionar valor',
    duplicateValue: 'Valor duplicado',
    kinds: 'Tipos de recurso',
    kindsAll: 'Todos',
    kindsPlaceholder: 'Todos',
    kindsHint: 'Deixe vazio para admitir todos os tipos de recurso que aceitam tags',
    systemChip: 'Sistema',
    deleteCascade: 'Remover também as atribuições',
    deleteCascadeHint: 'Uma etiqueta ainda atribuída a algum recurso é recusada: com esta opção os valores e todas as atribuições vão-se embora juntamente com a etiqueta.'
  },
  scopes: {
    title: 'Scopes',
    createTitle: 'Criar scope',
    editTitle: 'Renomear scope',
    path: 'Caminho',
    segment: 'Segmento',
    segmentHint: 'Minúsculas, dígitos e hífenes (DNS-1123)',
    parent: 'Pai',
    rootChip: 'Raiz',
    preview: 'Novo scope',
    pickLabel: 'Scope',
    pickHint: 'Onde o objeto vive na árvore do cluster — a raiz ou um vDC dentro dela.',
    ociCache: 'Cache OCI (override)',
    appEphemeral: 'Pool efémero de App (override)',
    inherit: 'Herdar',
    inheritsFrom: 'Herda de',
    inheritsCluster: 'Herda o default do cluster',
    inheritsNone: 'Herda — nenhum pool efetivo',
    failoverProtection: 'Proteção em degradado',
    networkWeight: 'Peso de rede',
    networkCeil: 'Teto de rede (Mbps)',
    protectionProtected: 'Protegida',
    protectionExpendable: 'Sacrificável em degradado',
    protectionDefault: 'Predefinição do cluster'
  },
  sysinfo: {
    summary: 'Versões da plataforma no cluster, componentes de cada nó, manual de administração e licença.',
    platformTitle: 'Plataforma TVirt',
    platformSubtitle: 'Versões observadas nos nós do cluster',
    versionOnNodes: '{version} em {n} nós',
    versionOnOneNode: '{version} em 1 nó',
    mixedVersions: 'Mais do que uma versão da plataforma no cluster — esperado só durante uma atualização em curso (no máximo duas).',
    tooManyVersions: 'Mais do que duas versões da plataforma no cluster — nunca é esperado, nem sequer durante uma atualização: verifique os nós abaixo.',
    unreportedNodes: 'Ainda nenhum report de versões de: {nodes}',
    noVersionsYet: 'Nenhum nó reportou ainda as suas versões.',
    nodesUnavailable: 'A lista de nós não é visível com as suas permissões — impossível mostrar as versões da plataforma.',
    colNode: 'Nó',
    manualTitle: 'Manual de administração',
    manualSubtitle: 'Cópia local, servida por este cluster',
    manualBody: 'O manual TVirt completo em PDF, servido diretamente pela plataforma — disponível também em ambientes air-gapped.',
    manualLink: 'Manual de administração (PDF)',
    apiExplorerTitle: 'Explorador de API',
    apiExplorerSubtitle: 'O contrato OpenAPI, navegável',
    apiExplorerBody: 'O contrato OpenAPI completo da plataforma — cada rota, esquema e código de resposta — explorável a partir do navegador, servido através deste nó.',
    apiExplorerLink: 'Explorar a API',
    kubeTitle: 'Compatibilidade Kubernetes',
    kubeSubtitle: 'kubectl e as suas ferramentas, à frente da API nativa',
    kubeBody: 'O TVirt KubeCompat projeta Pods, Deployments, Services, namespaces, nós e eventos no dialeto Kubernetes — só leitura, mais a eliminação de Deployments. Cada chamada passa pela API nativa com as tuas permissões: no kubeconfig usa um app token como bearer.',
    kubeEndpoint: 'Endpoint para kubectl',
    kubeStatusActive: 'Ativo — Kubernetes {version}',
    kubeStatusMissing: 'Não instalado neste nó (pacote trantor-tvirt-kubecompat)',
    kubeStatusDown: 'Instalado mas não responde — verifica a unidade trantor-tvirt-kubecompat',
    kubeStatusChecking: 'A verificar…'
  },
  licensing: {
    title: 'Licença do cluster',
    subtitle: 'Licença por subscrição — no máximo uma por cluster',
    absentTitle: 'Nenhuma licença registada',
    absentBody:
      'Sem uma licença válida o cluster recusa arrancar novas máquinas virtuais (as VMs ligadas continuam ligadas). Registe o product key recebido com a subscrição.',
    registerButton: 'Registar licença',
    removeButton: 'Remover licença',
    state: {
      ok: 'Válida',
      limitExceeded: 'Limite excedido',
      expired: 'Expirada'
    },
    productKeyLabel: 'Product key',
    basisLabel: 'Base do limite',
    basis: {
      concurrentVms: 'VMs ligadas em simultâneo',
      physicalCores: 'Cores físicos (total do cluster)'
    },
    limitLabel: 'Limite',
    usageLabel: 'Utilização atual',
    usageOf: '{used} de {limit}',
    usagePartial: 'soma parcial — {n} nó(s) sem topologia de CPU observada',
    usageUnknown: 'não observável neste momento',
    expiresLabel: 'Expiração',
    neverExpires: 'nunca',
    registeredLabel: 'Registada',
    gateNote:
      'Com a licença ausente, expirada ou além do limite o cluster recusa arrancar NOVAS máquinas virtuais. As VMs ligadas continuam ligadas e os reinícios HA não são afetados.',
    devStage:
      'Fase de desenvolvimento: o product key é aceite tal como está, juntamente com os limites aqui declarados; a validação com chave assinada chegará numa release futura.',
    dialogTitle: 'Registar licença',
    dialogExpiresHelp: 'Vazio = a licença nunca expira',
    dialogSubmit: 'Registar',
    dialogError: 'Impossível registar a licença.',
    removeTitle: 'Remover licença',
    removeBody:
      'O cluster ficará SEM LICENÇA: as novas máquinas virtuais recusarão arrancar enquanto não registar uma. As VMs ligadas continuam ligadas.',
    removeConfirm: 'Remover',
    removeError: 'Impossível remover a licença.'
  },
  rbac: {
    tabRoles: 'Funções',
    tabGrants: 'Delegações',
    rolesTitle: 'Funções',
    createRoleTitle: 'Criar função',
    editRoleTitle: 'Editar função',
    nameHint: 'Minúsculas, dígitos e hífenes; o prefixo tvirt- está reservado',
    systemChip: 'Sistema',
    permissions: 'Permissões',
    permissionsPlaceholder: 'Adicionar permissão…',
    includedRoles: 'Funções incluídas',
    includedRolesPlaceholder: 'Adicionar função…',
    grantsTitle: 'Delegações',
    createGrantTitle: 'Criar delegação',
    principal: 'Principal',
    principalKind: 'Tipo de principal',
    principalUser: 'Utilizador',
    principalGroup: 'Grupo',
    role: 'Função',
    grantRight: 'Delegação',
    grantRightChip: 'Pode delegar',
    grantRightLabel: 'Com direito de delegação (o destinatário pode por sua vez delegar esta função)',
    effective: 'Efetiva',
    notEffective: 'Não efetiva',
    createdAt: 'Criada',
    scopeHint: '/path exato, /path/* recursivo — as delegações ancoram-se numa raiz montada (/* não é delegável)'
  },
  groups: {
    title: 'Grupos',
    createTitle: 'Criar grupo',
    nameHint: 'Minúsculas, dígitos e hífenes; único dentro do scope',
    members: 'Membros',
    membersTitle: 'Membros',
    membersPlaceholder: 'Adicionar utilizador…',
    noMembers: 'Nenhum membro',
    realmMappings: 'Mapeamentos de realm',
    realmMappingsTitle: 'Mapeamentos de realm',
    realmMappingsHint:
      'A que corresponde este grupo em cada realm externo. A pertença lê-se da directory no momento do início de sessão: um grupo de directory que ninguém mapeia aqui é ignorado, e o aninhamento não é resolvido — aplane-o do lado da directory.',
    realm: 'Realm',
    externalGroup: 'Grupo externo',
    addRealmMapping: 'Adicionar mapeamento',
    removeRealmMapping: 'Remover mapeamento',
    noRealmMappings: 'Nenhum mapeamento de realm',
    sectionGeneral: 'Geral',
    mappingsNoRealms: 'Nenhum realm externo configurado — a superfície de mapeamento desbloqueia-se assim que existir um realm.',
    mappingsNoRealmsLink: 'Abrir o tab Realms e SSO',

    // A obrigação de MFA imposta pelo grupo (round #178 metade B): OR puro —
    // um grupo só pode ACRESCENTAR a obrigação, nunca retirá-la.
    mfaRequired: 'Obrigação de MFA',
    mfaRequiredChip: 'Impõe a MFA',
    mfaNotRequiredChip: 'Sem obrigação',
    mfaRequiredHint:
      'OR puro: um grupo pode ACRESCENTAR a obrigação do segundo fator aos seus membros — também às identidades externas, via mapeamentos de realm — nunca retirá-la. Vale a partir do próximo início de sessão: as sessões abertas não são fechadas.'
  },
  users: {
    title: 'Utilizadores',
    createTitle: 'Criar utilizador',
    editTitle: 'Editar utilizador',
    username: 'Nome de utilizador',
    usernameHint: 'Minúsculas, dígitos, pontos e hífenes',
    displayName: 'Nome apresentado',
    enabled: 'Ativado',
    state: 'Estado',
    enabledChip: 'Ativado',
    disabledChip: 'Desativado',
    lockedChip: 'Bloqueado',
    password: 'Palavra-passe',
    passwordSetChip: 'Definida',
    mustChangeChip: 'Por alterar',
    initialPassword: 'Palavra-passe inicial',
    initialPasswordHint: 'O utilizador terá de a alterar no primeiro início de sessão',
    lastLogin: 'Último acesso',
    neverLoggedIn: 'Nunca entrou',
    setPasswordTitle: 'Definir palavra-passe',
    setPasswordHint: 'Substituição administrativa — exige a sua palavra-passe (modo sudo) e obriga o utilizador a alterá-la no próximo início de sessão.',
    operatorPassword: 'A sua palavra-passe',
    unlock: 'Desbloquear o account',
    revokeTitle: 'Revogar sessões',
    revokeBody: 'Todas as sessões ativas deste utilizador são terminadas imediatamente.',
    revokeIncludeTokens: 'Revogar também os app tokens',
    revokeConfirm: 'Revogar',
    tabAccount: 'Account',
    tabSecurity: 'Segurança',
    usernameImmutableHint: 'O nome de utilizador é a identidade do account — fixado na criação',
    groups: 'Grupos',
    noGroups: 'Nenhum grupo',
    mustChangePassword: 'Mudança de palavra-passe obrigatória',
    failedAttempts: 'Tentativas de acesso falhadas',
    lockedUntil: 'Bloqueado até',
    tabUsers: 'Utilizadores',
    tabGroups: 'Grupos',
    tabRealms: 'Realms e SSO',
    tabMfa: 'MFA',
    mfa: {
      title: 'Segundo fator (MFA)',
      methodsTitle: 'Métodos disponíveis',
      methodsSubtitle: 'O que esta instalação sabe verificar como segundo fator',
      methodsError: 'Não foi possível carregar o registo de métodos',
      builtinChip: 'Integrado',
      enrollableChip: 'Enrollment no TVirt',
      delegatedChip: 'Gerido externamente',
      state: 'Estado',
      stateActive: 'Ativo',
      statePending: 'A aguardar enrollment',
      stateNone: 'Sem enrollment concluído',
      required: 'Obrigação de MFA',
      requiredChip: 'Obrigatório',
      notRequiredChip: 'Não obrigatório',
      enrolledAt: 'Enrollment de',
      enrolledMethods: 'Métodos inscritos',
      noMethods: 'Sem enrollment',
      codesRemaining: 'Códigos de recuperação restantes',
      resetTitle: 'Repor o segundo fator',
      resetHint:
        'O enrollment e todos os códigos de recuperação são apagados: no próximo início de sessão o utilizador refaz o enrollment do zero. A obrigação de MFA fica como está — um administrador nunca define um segredo, apenas o apaga.',
      resetConfirm: 'Repor',
      resetError: 'Não foi possível repor o segundo fator',
      empty: 'Ainda nenhum utilizador gerido — as contas aparecem aqui assim que existem, cada uma com o seu estado do segundo fator.',

      // Metade B (round #178): proveniência do veredicto efetivo, enrollments
      // externos com o estado órfão, grupos que impõem a obrigação.
      viaSelf: 'Pessoal',
      viaSelfHint: 'A contribuição pessoal da conta (o seu flag) — a única parte que o lápis modifica.',
      viaGroupHint: 'Obrigação herdada deste grupo: retirar o flag pessoal não liberta o utilizador — intervém-se no grupo, no tab Grupos.',
      subject: 'Identidade',
      lastSeenAt: 'Última confirmação',
      enrollmentPending: 'Pendente',
      orphanChip: 'Órfão',
      orphanDirectoryMiss: 'A identidade já não está na directory',
      orphanRealmRemoved: 'O realm foi removido do TVirt',
      orphanedAt: 'Órfão desde',
      directoryUuid: 'UUID na directory',
      externalTitle: 'Enrollments externos',
      externalEmpty: 'Ainda nenhum enrollment externo — nasce no primeiro início de sessão de uma identidade de directory com a obrigação de MFA.',
      orphanHelp:
        'Um enrollment órfão nunca se apaga sozinho: é material de segurança — fica para a auditoria e, se a identidade reaparecer na directory, reencontra o seu fator. A única saída é a reposição administrativa.',
      visibilityHint: 'Os enrollments externos residem na raiz do cluster: só os vê quem tem user.read sobre a árvore inteira.',
      orphanResetHint:
        'A linha órfã é removida definitivamente: já ninguém a reclama. Se a identidade voltar a aparecer na directory, refará o enrollment do zero.',
      enforcingTitle: 'Grupos que impõem a MFA',
      enforcingSubtitle:
        'A âncora da obrigação para as identidades externas é o grupo: os seus mapeamentos de realm dizem a que população de directory chega. O enrollment externo nasce no primeiro início de sessão do utilizador obrigado.',
      enforcingEmpty: 'Nenhum grupo impõe a MFA — a obrigação ativa-se no grupo, a partir do tab Grupos.',
      enforcingError: 'Não foi possível carregar os grupos que impõem a MFA'
    }
  },
  realms: {
    title: 'Realms de autenticação',
    createTitle: 'Criar realm',
    editTitle: 'Editar realm',
    name: 'Realm',
    nameHint: 'O domínio que os utilizadores escrevem depois do @ (example.com) — imutável depois da criação',
    nameImmutableHint: 'O nome do realm fica estampado em cada sessão e em cada linha de audit que alguma vez o nomeou — renomeá-lo reescreveria a história',
    kind: 'Tipo',
    kindLdap: 'LDAP / Active Directory',
    kindHint: 'OIDC e SAML chegam com os próximos rounds — hoje um realm é uma directory LDAPv3',
    kindCategory: 'Tipo de realm',
    kindSelectHint: 'Selecione o tipo de directory contra a qual este realm vai autenticar.',
    kindCard: {
      ldap: {
        name: 'LDAP / Active Directory',
        desc: 'Username e palavra-passe verificados com um bind numa directory LDAPv3 — Active Directory, FreeIPA, OpenLDAP.'
      },
      oidc: {
        name: 'OpenID Connect',
        desc: 'Single sign-on a partir do browser delegado num identity provider OpenID Connect — chega com os próximos rounds.'
      },
      saml: {
        name: 'SAML 2.0',
        desc: 'Single sign-on empresarial com asserções SAML 2.0 — chega com os próximos rounds.'
      }
    },
    tabBind: 'Bind',
    enabled: 'Ativado',
    urls: 'Servidores da directory',
    urlsHint: 'Um URL ldap:// ou ldaps:// por linha (1–8), tentados por ordem — failover, nunca balanceamento',
    startTls: 'StartTLS',
    verifyCertificate: 'Verificar o certificado',
    cleartextWarning: 'Sem ldaps:// ou StartTLS a palavra-passe de bind atravessa a rede em claro — aceitável num laboratório, nunca em produção.',
    noVerifyWarning: 'Uma sessão TLS não verificada não autentica ninguém: desative a verificação só contra uma directory que não possa corrigir.',
    caCertificate: 'Certificado CA (PEM)',
    caCertificateHint: 'Bundle CA opcional fixado para o handshake TLS/StartTLS deste realm; vazio remove-o',
    caCertificatePinned: 'Fixado',
    connectTimeout: 'Timeout (segundos)',
    connectTimeoutHint: 'Prazo por URL de ligação e pedido (1–60); ao expirar tenta-se o URL seguinte',
    bindDn: 'Bind DN',
    bindDnHint: 'O service account que executa a pesquisa do utilizador; vazio = search bind anónimo (recusado pelo AD)',
    anonymousBind: 'Search bind anónimo',
    bindCredential: 'Palavra-passe de bind (keystore)',
    bindCredentialHint: 'Uma entrada usernamePassword do keystore com a palavra-passe de bind — o segredo nunca vive no realm',
    bindCredentialNone: 'Nenhuma (bind anónimo)',
    bindCredentialEmpty: 'Nenhuma entrada usernamePassword no keystore — crie uma em Sistema > Credenciais para a palavra-passe de bind.',
    baseDn: 'Base DN',
    baseDnHint: 'A subárvore de onde parte a pesquisa do utilizador (DC=example,DC=com)',
    userFilter: 'Filtro de utilizador',
    userFilterHint: '%u é substituído pela parte local do login, com escape RFC 4515; as directories não-AD tipicamente querem (&(objectClass=inetOrgPerson)(uid=%u))',
    memberOfAttribute: 'Atributo memberOf',
    memberOfAttributeHint: 'Lido uma única vez, no login — os grupos não mapeados são ignorados, o aninhamento não se resolve',
    uuidAttribute: 'Atributo UUID',
    uuidAttributeHint: 'O UUID imutável no realm (objectGUID no AD, entryUUID no OpenLDAP) — estampado no audit ao lado de utilizador@realm',
    displayNameAttribute: 'Atributo do nome apresentado',
    displayNameAttributeHint: 'Usado para saudar o utilizador; na falta usa-se o nome de login',
    sudoHint: 'As escritas nos realms são protegidas por sudo: um realm é uma porta de entrada na plataforma',
    deleteBody: 'Os mapeamentos de grupos do realm vão com ele; as sessões que autenticou continuam vivas até expirarem — um realm eliminado simplesmente já não admite ninguém novo.',
    tabConnection: 'Ligação',
    tabDirectory: 'Directory',
    testTitle: 'Testar ligação',
    testHint: 'Uma sonda de configuração, nunca uma autenticação: liga-se, faz o bind com o service account e — com um username — executa o filtro de utilizador.',
    testUsername: 'Nome de utilizador (opcional)',
    testUsernameHint: 'Uma parte local sobre a qual executar o filtro de utilizador — 1 correspondência é a resposta saudável',
    testRun: 'Executar teste',
    testError: 'Impossível executar a sonda',
    testReachable: 'Directory alcançável, bind de serviço aceite',
    testUnreachable: 'Directory NÃO alcançável',
    matchedOne: 'O filtro de utilizador encontrou exatamente 1 entrada — a resposta saudável.',
    matchedNone: 'O filtro de utilizador não encontrou nenhuma entrada: o filtro ou o base DN está errado.',
    matchedMany: 'O filtro de utilizador encontrou {count} entradas: não é seletivo, e os inícios de sessão seriam ambíguos (recusados).',
    mappingsPointer: 'A que corresponde um grupo externo é uma propriedade do grupo TVirt (os seus mapeamentos de realm): o ponto de verdade vive no tab Grupos.',
    mappingsPointerLink: 'Abrir o tab Grupos',
    rootHomeHint: 'As identidades de um realm externo vivem na raiz do cluster, nunca num vDC: as permissões atribuem-se onde forem precisas, com delegações — no grupo ou diretamente no utilizador, exatamente como para os nativos.'
  },
  credentials: {
    title: 'Credenciais',
    createTitle: 'Criar credencial',
    editTitle: 'Editar credencial',
    kind: 'Tipo',
    kindUsernamePassword: 'Username e palavra-passe',
    kindIscsiChap: 'CHAP (iSCSI)',
    kindNvmeDhchap: 'DH-HMAC-CHAP (NVMe)',
    kindCephx: 'cephx (identidade Ceph)',
    kindHintUsernamePassword: 'Imutável. Para os storages CIFS/SMB — o account de mount cujo segredo o worker usa no momento do mount.',
    kindHintIscsiChap: 'Imutável. Para a autenticação CHAP iSCSI — username = nome CHAP, secret = segredo CHAP.',
    kindHintNvmeDhchap: 'Imutável. Para o DH-HMAC-CHAP do NVMe over Fabrics — secret = o blob DHHC-1:xx:…; o username é só uma etiqueta.',
    kindHintCephx: 'Imutável. Para os clients Ceph — username = nome do client (client.…), secret = a chave base64.',
    kindImmutableHint: 'O tipo é imutável depois da criação — mudá-lo significa uma nova credencial.',
    username: 'Nome de utilizador',
    usernameChap: 'Nome CHAP',
    usernameNvme: 'Etiqueta',
    usernameCephx: 'Nome do client',
    usernameHint: 'Account opcional a que pertence o segredo',
    usernameHintChap: 'O nome CHAP com que o initiator se autentica',
    usernameHintNvme: 'Não usada pelo transporte — uma etiqueta livre para os seus apontamentos',
    usernameHintCephx: 'O nome do client cephx — o prefixo client. é tolerado',
    secret: 'Segredo',
    secretHint: 'Só de escrita: usado pelos consumidores, nunca mais mostrado.',
    secretHintNvmeDhchap: 'Só de escrita: o segredo DH-HMAC-CHAP do host na forma canónica DHHC-1:xx:… — usado pelos consumidores, nunca mais mostrado.',
    secretHintCephx: 'Só de escrita: a chave cephx base64 — usada pelos consumidores, nunca mais mostrada.',
    secretEditHint: 'Deixe vazio para não alterar o segredo — preenchê-lo roda-o.',
    createdAt: 'Criada',
    inUseError: "'{name}' é referenciada pela configuração de um storage — desassocie-a lá primeiro.",
    nameHint: 'Minúsculas, dígitos e hífenes (DNS-1123); única por scope',
    rotateTitle: 'Rodar segredo',
    rotateHint: 'Só de escrita: o novo segredo substitui o memorizado — os consumidores usá-lo-ão no próximo mount.',
    tabSecrets: 'Segredos',
    tabCertificates: 'Certificados',
    tabAuthorities: 'Autoridades de certificação',
    certificatesTitle: 'Certificados',
    authoritiesTitle: 'Autoridades de certificação',
    caCreateTitle: 'Nova CA',
    certCreateTitle: 'Novo certificado',
    caMode: 'Origem',
    caModeGenerate: 'Gerar com o TVirt',
    caModeImport: 'Importar (chave + certificado)',
    certMode: 'Origem',
    certModeIssue: 'Emitir a partir de uma CA do keystore',
    certModeImport: 'Importar (chave + certificado)',
    issuingCa: 'CA emissora',
    issuingCaHint: 'O certificado nasce no scope da CA, com o parent registado',
    noCasHint: 'Nenhuma CA no keystore — gere ou importe primeiro uma no tab CA',
    commonName: 'Common name (CN)',
    commonNameCaHint: 'O subject da CA: letras, dígitos, espaço, ponto, underscore, hífen',
    commonNameCertHint: 'O OpenVPN identifica os clients pelo CN — mantenha-o único por CA',
    days: 'Validade (dias)',
    daysCaHint: '1–7300 dias; 3650 (10 anos) é o default',
    daysCertHint: '1–3650 dias; 365 é o default',
    keyType: 'Tipo de chave',
    keyTypeHint: 'EC P-256 é o default; RSA para consumidores legacy',
    usage: 'Uso',
    usageClient: 'Client (clientAuth)',
    usageServer: 'Server (serverAuth)',
    usageHint: 'O extended key usage para o qual o certificado é emitido',
    san: 'Nomes alternativos (SAN)',
    sanHint: 'Separados por vírgula; os IPs literais tornam-se entradas IP:, o resto DNS:',
    keyPem: 'Chave privada (PEM)',
    keyPemHint: 'Só de escrita: guardada no keystore, nunca mais mostrada',
    certPem: 'Certificado (PEM)',
    certPemHint: 'O certificado público que emparelha com a chave',
    certPemCaHint: 'O certificado CA que emparelha com a chave (basicConstraints CA)',
    subject: 'Subject',
    issuer: 'Emissor',
    parentCa: 'CA emissora',
    parentCaImported: 'Importado — emitido fora do TVirt',
    serial: 'Número de série',
    fingerprint: 'Fingerprint (SHA-256)',
    validFrom: 'Válido desde',
    validUntil: 'Válido até',
    expiry: 'Expiração',
    expired: 'Expirado',
    expiresInDays: 'Expira em {days} d',
    revoked: 'Revogado',
    revokedAtLabel: 'Revogado a',
    revokeTitle: 'Revogar certificado',
    revokeAction: 'Revogar',
    revokeWarning: 'A revogação é definitiva: o número de série entra na CRL da CA emissora e todos os consumidores que recusam certificados revogados (o OpenVPN em primeiro lugar) rejeitarão este. Não existe un-revoke.',
    exportPem: 'Exportar PEM',
    exportChain: 'Exportar bundle da cadeia',
    exportCrl: 'Exportar CRL',
    materialImmutableHint: 'O material X.509 é imutável — reemita ou reimporte',
    caInUseError: "'{name}' ainda tem certificados emitidos vivos (ou um storage referencia-a) — revogue-os ou elimine-os primeiro."
  },
  proximity: {
    title: 'TVirt Proximity',
    subtitle: 'Colocação, disponibilidade e afinidade — onde correm as VMs do cluster e se devem estar ligadas',
    loadError: 'O painel Proximity precisa do store de cluster — o estado da frota não está alcançável neste momento',
    config: {
      title: 'Configuração',
      subtitle: 'Política de colocação ao nível do cluster',
      save: 'Guardar',
      saveError: 'A configuração foi recusada',
      strategy: 'Estratégia de seleção',
      strategy_leastUsedResources: 'Menos recursos usados',
      strategy_leastVms: 'Menos VMs',
      strategy_random: 'Aleatória',
      strategyLeastUsedResourcesHint: 'Entre os candidatos válidos, o nó com mais RAM usável restante (total observado − reserva do host − VMs ligadas), compromisso de vCPU como desempate. Determinística com dados iguais.',
      strategyLeastVmsHint: 'Entre os candidatos válidos, o nó com menos VMs ligadas; os empates resolvem-se pelo nome. Determinística com dados iguais.',
      strategyRandomHint: 'Uniformemente aleatória entre os candidatos válidos.',
      liveness: 'Limiar de vitalidade dos nós (segundos)',
      livenessHint: 'Um membro silencioso para lá do limiar está inalcançável: excluído da colocação e — se não estiver em manutenção — considerado morto pelo decider HA, que o isola e reinicia as suas VMs HA noutro lugar.',
      decider: 'Decider HA',
      deciderNone: 'ainda não eleito'
    },
    nodesTitle: 'Nós',
    nodesSubtitle: 'Vitalidade e capacidade empírica — RAM usável = total − base − comprometida',
    nodeCol: 'Nó',
    stateCol: 'Estado',
    ramCol: 'RAM (total − base − comprometida)',
    usableCol: 'Usável',
    vmsCol: 'Carga',
    neverSeen: 'nunca visto',
    freshChip: 'alcançável',
    staleChip: 'inalcançável',
    attestedChip: 'atestado desligado',
    ramFormula: 'total − base − comprometida',
    haTitle: 'Alta disponibilidade',
    haSubtitle: 'As VMs com a flag HA são "sempre ligadas": o TVirt reinicia-as depois de cada paragem não pedida — mesmo nó com backoff, outro nó quando o delas morre (só storage partilhado).',
    haNone: 'Nenhuma VM tem ainda a flag HA — ative-a aqui ou no detalhe da VM.',
    haVmCol: 'Máquina virtual',
    haStateCol: 'Estado',
    haRestartsCol: 'Reinícios HA',
    haLastEventCol: 'Último evento',
    haToggleCol: 'HA',
    haCrashLoop: 'crash loop',
    haToggleError: 'A alteração HA foi recusada',
    rules: {
      title: 'Regras de afinidade',
      createTitle: 'Nova regra de proximidade',
      editTitle: 'Editar regra',
      nameHint: 'Minúsculas, dígitos e hífenes (etiqueta DNS)',
      vms: 'Máquinas virtuais',
      vmsHint: 'Pelo menos duas VMs — a regra vincula onde correm umas em relação às outras',
      type: 'Tipo',
      affinity: 'Afinidade (juntas)',
      antiAffinity: 'Anti-afinidade (separadas)',
      typeAffinityHint: 'As VMs devem correr no MESMO nó.',
      typeAntiAffinityHint: 'As VMs devem correr em nós DIFERENTES — o clássico par HA.',
      mode: 'Modo',
      hard: 'hard',
      soft: 'soft',
      modeHardHint: 'As violações recusam a operação (arranque, migração, failover) com um erro falante.',
      modeSoftHint: 'Preferência, nunca bloqueante: uma colocação em violação prossegue com um aviso visível.',
      satisfied: 'Colocação',
      satisfiedYes: 'respeitada',
      satisfiedNo: 'violada',
      violations: 'Violações',
      noViolations: 'Nenhuma'
    },
    events: {
      title: 'Eventos HA',
      subtitle: 'O diário da disponibilidade — reinícios, fencing, failovers e as omissões honestas',
      none: 'Ainda nada.',
      when: 'Quando',
      kind: 'Evento',
      target: 'Objeto',
      detail: 'Detalhe',
      kindRestarted: 'reinício HA',
      kindGaveUp: 'desistência (crash loop)',
      kindNodeAttested: 'nó isolado',
      kindFailedOver: 'failover',
      kindNoCandidate: 'nenhum candidato',
      kindStorageLocalSkip: 'saltado (storage local)',
      kindZombieFenced: 'zombie terminado'
    }
  }
}
